import React from 'react';
import { motion } from 'framer-motion';

export function BrandMark({ variant }) {
  const mode = variant || 'default';

  if (mode === 'sidebar') {
    return (
      <motion.div
        initial={{ opacity: 0, scale: 0.96 }}
        animate={{ opacity: 1, scale: 1 }}
        transition={{ duration: 0.25 }}
        className="brand-block brand-block-sidebar"
      >
        <motion.div
          whileHover={{ rotate: 5, scale: 1.04 }}
          whileTap={{ scale: 0.97 }}
          className="brand-mark brand-mark-image"
        >
          <img src="/hk-brand-logo.png" alt="HK Identity" />
        </motion.div>
        <span className="brand-name">Identity</span>
      </motion.div>
    );
  }

  return (
    <motion.div
      initial={{ opacity: 0, scale: 0.96 }}
      animate={{ opacity: 1, scale: 1 }}
      transition={{ duration: 0.25 }}
      className="brand-block"
    >
      <motion.div
        whileHover={{ rotate: 8, scale: 1.05 }}
        whileTap={{ scale: 0.95 }}
        className="brand-mark brand-mark-image"
      >
        <img src="/hk-brand-logo.png" alt="HK Identity" />
      </motion.div>
      <span className="brand-name">Identity</span>
    </motion.div>
  );
}
